import { zodResolver } from '@hookform/resolvers/zod';
import type { PropsWithChildren } from '@shared/utils';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import {
  QConfigStructureSchema,
  type QConfigStructureFormInput,
} from './qconfig-structure-form-schema';

interface QConfigFormProviderProps extends PropsWithChildren {
  initialValues?: QConfigStructureFormInput;
}

export default function QConfigStructureFormProvider(props: Readonly<QConfigFormProviderProps>) {
  const { initialValues, children } = props;

  const formContext = useForm<QConfigStructureFormInput>({
    mode: 'onChange',
    defaultValues: initialValues ?? {},
    resolver: zodResolver(QConfigStructureSchema),
  });

  useEffect(() => {
    formContext.reset(initialValues ?? {});
  }, [initialValues]);

  return <FormProvider {...formContext}>{children}</FormProvider>;
}
